import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LeftControls = _resolveComponent("LeftControls")
  const _component_InputText = _resolveComponent("InputText")
  const _component_RightControls = _resolveComponent("RightControls")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["input-controls", {expanded: $data.input_expanded}]),
    style: _normalizeStyle({'--left-padding': $options.left_padding}),
    relative: ""
  }, [
    _createVNode(_component_LeftControls, {
      class: "left",
      disabled: $props.recording,
      "uploads-enabled": $props.uploadsEnabled,
      "can-upload": $props.canUpload,
      onUpload: _cache[0] || (_cache[0] = $event => (_ctx.$emit('upload'))),
      onPrompt: $options.onPrompt,
      onSkill: _cache[1] || (_cache[1] = $event => ($options.setCommand($event))),
      onSource: _cache[2] || (_cache[2] = $event => ($options.setCommand($event))),
      onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
    }, null, 8 /* PROPS */, ["disabled", "uploads-enabled", "can-upload", "onPrompt"]),
    _createVNode(_component_InputText, {
      ref: "input",
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.value) = $event)),
      class: "input-block",
      "allow-resize": $data.input_expanded,
      "editor-disabled": $props.recording,
      placeholder: $props.placeholder,
      onPush: $options.onPush,
      onFocusin: _cache[5] || (_cache[5] = $event => (_ctx.$emit('focusin', $event))),
      onFocusout: _cache[6] || (_cache[6] = $event => (_ctx.$emit('focusout', $event))),
      onStop: $options.onStop,
      onRows: _cache[7] || (_cache[7] = $event => ($options.handleRow($event)))
    }, null, 8 /* PROPS */, ["modelValue", "allow-resize", "editor-disabled", "placeholder", "onPush", "onStop"]),
    _createVNode(_component_RightControls, {
      "can-push": $props.canPush,
      generating: $props.generating,
      onPush: $options.onPush,
      onStop: $options.onStop,
      onTranscribed: $options.onTranscribed
    }, null, 8 /* PROPS */, ["can-push", "generating", "onPush", "onStop", "onTranscribed"])
  ], 6 /* CLASS, STYLE */))
}